import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class AssignmentsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllAssignments(router){
    const url = `/api/assignments`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getAssignmentById(id, router) {
    const url = `/api/assignments/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getGradedAssignmentForStudent(studentId, assignmentId, router){
    const url = `/api/assignments/gradedAssignment/${studentId}/${assignmentId}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  duplicateAssignment(id, router){
    const url = `/api/assignments/duplicate/${id}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  createAssignment(params, router) {
    const url = `/api/assignments`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateAssignment(id, params, router) {
    const url = `/api/assignments/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteAssignment(id, router) {
    const url = `/api/assignments/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  // Student Assignments
  getAllStudentAssignments(router){
    const url = `/api/assignments/studentAssignments`
    return this.CommonAPIService.getCall(url, null, router)
  }
  getStudentAssignmentsForStudent(studentId, router){
    const url = `/api/assignments/studentAssignments/student/${studentId}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getStudentAssignmentById(id, router) {
    const url = `/api/assignments/studentAssignments/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createStudentAssignment(params, router) {
    const url = `/api/assignments/studentAssignments/`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateStudentAssignment(id, params, router) {
    const url = `/api/assignments/studentAssignments/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteStudentAssignment(id, router) {
    const url = `/api/assignments/studentAssignments/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  // Assignments Types
  getAllAssignmentTypes(router){
    const url = `/api/assignments/assignmentTypes`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getAssignmentTypeById(id, router) {
    const url = `/api/assignments/assignmentTypes/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createAssignmentType(params, router) {
    const url = `/api/assignments/assignmentTypes/`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateAssignmentType(id, params, router) {
    const url = `/api/assignments/assignmentTypes/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteAssignmentType(id, router) {
    const url = `/api/assignments/assignmentTypes/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default AssignmentsAPIService;
